import request from '@/utils/request'

let CloudApi = {

  /*跨境云列表*/
  list(data) {
    return request._post('/shop/plus.cloud.Index/index', data);
},
/*添加跨境云*/
add(data) {
    return request._post('/shop/plus.cloud.Index/add', data);
},
/*修改跨境云*/
edit(data) {
    return request._post('/shop/plus.cloud.Index/edit', data);
},
/*删除跨境云*/
del(data) {
    return request._post('/shop/plus.cloud.Index/del', data);
},
/*跨境云详情*/
detail(data) {
  return request._post('/shop/plus.cloud.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.cloud.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.cloud.Setting/getSetting', data, errorback);
    },
}
export default CloudApi;



// WEBPACK FOOTER //
// ./src/api/cloud.js